import { render } from "./TheFooter.vue?vue&type=template&id=d7cc465c"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=d7cc465c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__